<template>
  <div class="elr-conent">
    <div class="lefts">
      <el-row :gutter="20" :data="apApply">
        <el-col :span="3">
          <div class="grid-content bg-purple">
            <div class="label">
              现汇实收金额：
              <span class="value">{{ apApply.cashAmt }}</span>
            </div>
            <div class="label">
              承兑实收金额：
              <span class="value">{{ apApply.acceptAmt }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <!-- <div class="label">
                         现汇银行账号：
                            <span
                                class="value"
                            >{{apApply.accountName}}</span>
                        </div> -->
            <!-- <div class="label">
                         现汇银行账号：
                            <span
                                class="value"
                            >{{apApply.acceptAccountName}}</span>
                        </div> -->
            <div>
              <el-form :model="apApply">
                <el-form-item label="现汇银行账号：">
                  <el-input
                    class="text-box"
                    readonly
                    v-model="apApply.accountName"
                  >
                    <el-button
                      slot="append"
                      :disabled="isSave"
                      icon="el-icon-search"
                      @click="bankSearch('account')"
                    ></el-button>
                    <!-- <i slot="suffix" :disabled="true" class="el-input__icon el-icon-circle-close"></i> -->
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
            <div>
              <el-form :model="apApply">
                <el-form-item
                  label="承兑银行账号："
                  prop="acceptAccountName"
                  :rules="
                    apApply.acceptAmt > '0'
                      ? [
                          {
                            required: true,
                            message: '承兑银行账号不能为空',
                            trigger: ['blur', 'change'],
                          },
                        ]
                      : [
                          {
                            required: false,
                            trigger: ['blur', 'change'],
                          },
                        ]
                  "
                >
                  <el-input
                    class="text-box"
                    readonly
                    v-model="apApply.acceptAccountName"
                  >
                    <el-button
                      slot="append"
                      :disabled="isSave"
                      icon="el-icon-search"
                      @click="bankSearch('accept')"
                    ></el-button>
                    <!-- <i slot="suffix" :disabled="true" class="el-input__icon el-icon-circle-close"></i> -->
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <div class="label">
              现汇开户名：

              <el-tooltip class="item" effect="light" placement="top-start">
                <span class="value">{{ apApply.bankUserName }}</span>
                <span class="value" slot="content">{{ apApply.bankUserName }}</span>
              </el-tooltip>
              <!-- <span class="value">{{ apApply.bankUserName }}</span> -->
            </div>
            <div class="label">
              承兑开户名：

              <el-tooltip class="item" effect="light" placement="top-start">
                <span class="value">{{ apApply.acceptBankUserName }}</span>
                <span class="value" slot="content">{{ apApply.acceptBankUserName }}</span>
              </el-tooltip>
            </div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <div class="label">
              现汇开户行：
              <el-tooltip class="item" effect="light" placement="top-start">
                <span class="value">{{ apApply.bankName }}</span>
                <span class="value" slot="content">{{ apApply.bankName }}</span>
              </el-tooltip>
            </div>
            <div class="label">
              承兑开户行：
              <el-tooltip class="item" effect="light" placement="top-start">
                <span class="value">{{ apApply.acceptBankName }}</span>
                <span class="value" slot="content">{{
                  apApply.acceptBankName
                }}</span>
              </el-tooltip>
              <!-- <span class="value">{{ apApply.acceptBankName }}</span> -->
            </div>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">
            <div class="label">
              现汇联行号：

              <el-tooltip class="item" effect="light" placement="top-start">
                <span class="value">{{ apApply.contractNumber }}</span>
                <span class="value" slot="content">{{
                  apApply.contractNumber
                }}</span>
              </el-tooltip>
              <!-- <span class="value">{{ apApply.contractNumber }}</span> -->
            </div>
            <div class="label">
              承兑联行号：

              <el-tooltip class="item" effect="light" placement="top-start">
                <span class="value">{{ apApply.acceptContractNumber }}</span>
                <span class="value" slot="content">{{
                  apApply.acceptContractNumber
                }}</span>
              </el-tooltip>
              <!-- <span class="value">{{ apApply.acceptContractNumber }}</span> -->
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <bank-dialog ref="advanceDialog" @confirm="confirm"></bank-dialog>
  </div>
</template>

<script>
import bankDialog from './bank-dialog';
export default {
    components: { bankDialog },
    props: {
        apApply: {
            type: Object
        },
        isSave: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            data: {}
        };
    },
    watch: {
        apApply: {
            handler(newVal, oldVal) {},
            immediate: true,
            deep: true
        }
    },
    methods: {
        bankSearch(tag) {
          if(this.apApply.ifClearPay == 'Y') {
            this.$message.warning('该单据属于【供应商结算透明化】范围，不允许修改为非美的付账户');
            return;
          }
          this.$refs.advanceDialog.show(true, {}, this.apApply, tag);
        },
        confirm(data, tag) {
            this.$emit('updateBank', data, tag);
            this.$forceUpdate();
        },
        reflush() {
            this.$forceUpdate();
        }
    }
};
</script>

<style lang="less">
.elr-conent {
  display: flex;
  .lefts {
    flex: 7;
    .el-form-item {
      margin-bottom: 0px;
    }
  }
  .rights {
    flex: 1;
    display: flex;
  }
  .rights-r {
    flex: -1;
    text-align: center;
  }
  .prices {
    margin-top: 6px;
    font-size: 24px;
    color: #ff8800;
  }
  .amount {
    font-size: 14px;
    color: #333;
    margin-top: 10px;
  }
  .prices-m {
    color: #000;
    font-size: 14px;
  }
  .text-box {
    width: 210px;
  }
}
</style>
